import React from 'react'
import Styles from './Styles.module.css'

// Normalize an options list into a consistent [{ value, label }] shape.
// Accepts plain strings ("Full-time") or objects ({ value, label }).
export function normalizeOptions(options = []) {
  if (!Array.isArray(options)) {
    return []
  }
  return options
    .map(opt => {
      if (typeof opt === 'string') {
        return { value: opt, label: opt }
      }
      if (opt && typeof opt === 'object') {
        const value = opt.value != null ? String(opt.value) : ''
        const label = opt.label != null ? String(opt.label) : value
        return { value, label }
      }
      return null
    })
    .filter(Boolean)
}

export default function Dropdown(props) {
  const { onChange, value, error, options } = props
  const normalizedOptions = normalizeOptions(options)

  // Collapse an empty or unmatched value to '' so the placeholder is shown.
  const currentValue = normalizedOptions.some(opt => opt.value === value) ? value : ''

  // Only render a placeholder entry while nothing valid is selected, so a
  // defaulted field (e.g. employment type defaulting to "Intern") shows just
  // its real options.
  const showPlaceholder = currentValue === ''

  return (
    <div className={Styles.inputWrapper}>
      {props.label ? (
        <label className={props.isRequired ? Styles.required : ''}>{props.label}</label>
      ) : null}
      <div className={Styles.inputContainer}>
        <select
          disabled={props.disabled}
          value={currentValue}
          onChange={e => onChange(e.target.value)}
          style={{
            width: '100%',
            border: 0,
            outline: 0,
            background: 'transparent',
            cursor: props.disabled ? 'not-allowed' : 'pointer',
          }}
        >
          {showPlaceholder ? (
            <option value="">{props.placeholder || 'Select...'}</option>
          ) : null}
          {normalizedOptions.map((opt, i) => (
            <option key={i} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>
      <div className={Styles.errorWrapper}>
        {error ? <p className={Styles.error}>{error}</p> : null}
      </div>
    </div>
  )
}
